const state = {
  uploadApp: null, // format { file: File, title: String, isResignable: Boolean }
  confirmData: null, // format { header: String, textTitle: String, text: String, actions: {confirm: String, cancel: String}, callback: function }
  notification: null, // format { type: String(success or error), text: String }
};

const getters = {
  getUploadApp(state) {
    return state.uploadApp;
  },
  getConfirmData(state) {
    return state.confirmData;
  },
  getNotification(state) {
    return state.notification;
  },
};

const mutations = {
  setUploadApp(state, value) {
    state.uploadApp = value;
  },
  setConfirmData(state, value) {
    state.confirmData = value;
  },
  setNotification(state, value) {
    state.notification = value;
  },
};

const actions = {
  emitUploadApp({ commit }, value) {
    commit("setUploadApp", value);
  },
  emitConfirmData({ commit }, value) {
    commit("setConfirmData", value);
  },
  emitNotification({ commit }, value) {
    commit("setNotification", value);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
